import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ArrowLeft, Mail } from "lucide-react";

export default function ForgotPassword({ isAdmin = false }) {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/auth/forgot-password", { email, is_admin: isAdmin });
            setDone(true);
            toast.success("Pedido enviado");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Erro inesperado");
        } finally {
            setBusy(false);
        }
    };

    const homeLink = isAdmin ? "/admin/login" : "/conta/login";

    return (
        <div className="min-h-screen bg-paper flex items-center justify-center p-6 grid-bg" data-testid="forgot-password-page">
            <div className="w-full max-w-md">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 mb-4 text-sm font-mono text-ink/60 hover:text-magenta"
                    data-testid="back-to-home-link"
                >
                    <ArrowLeft size={14} /> Voltar à loja
                </Link>
                <div className="border-2 border-ink bg-white p-8 shadow-[8px_8px_0_0_#0A0A0A]">
                    <div className="text-center mb-7">
                        <div className="inline-flex items-center justify-center w-14 h-14 border-2 border-ink bg-paper mb-3">
                            <Mail size={22} />
                        </div>
                        <h1 className="font-display font-black text-2xl">Recuperar senha</h1>
                        <p className="text-sm text-ink/60 mt-2 font-mono">
                            {isAdmin ? "Conta de administrador" : "Conta de cliente"}
                        </p>
                    </div>

                    {done ? (
                        <div data-testid="forgot-success">
                            <div className="border-2 border-magenta bg-magenta/5 p-4 mb-5">
                                <p className="text-sm">
                                    Se a conta <strong>{email}</strong> existir, foi enviado um email com
                                    instruções para redefinir a senha.
                                </p>
                                <p className="text-xs text-ink/60 mt-2 font-mono">
                                    O link expira em 1 hora. Verifique a pasta de spam.
                                </p>
                            </div>
                            <Link to={homeLink} className="btn-secondary w-full" data-testid="back-to-login-btn">
                                Voltar ao login
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={submit}>
                            <label className="block mb-5">
                                <span className="label-mono mb-2 block">Email da conta</span>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="input-edge"
                                    required
                                    autoFocus
                                    placeholder="o-seu@email.com"
                                    data-testid="forgot-email-input"
                                />
                            </label>
                            <button
                                type="submit"
                                disabled={busy || !email}
                                className="btn-primary w-full disabled:opacity-50"
                                data-testid="forgot-submit-btn"
                            >
                                {busy && <Loader2 className="animate-spin" size={16} />}
                                {busy ? "A enviar…" : "Enviar email de recuperação"}
                            </button>
                            <div className="mt-5 text-center">
                                <Link
                                    to={homeLink}
                                    className="text-sm font-mono text-ink/60 hover:text-magenta"
                                >
                                    ← Voltar ao login
                                </Link>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
